var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { FormAddBusinessAFY, ModalAFY, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { businessShiftList, businessShiftServicesList, FormsBusinessDTO, } from "./FormsBusinessDTO";
export var ModalAddBusiness = function (props) {
    return (_jsx(ModalAFY, __assign({ title: "", name: "", openModal: props.openModalAddBusiness, onClose: function () {
            props.setOpenModalAddBusiness(false);
        }, minWidthModal: "1000px", heightModal: "640px", backgroundColor: "#FFFFFF", closeModalOutside: true }, { children: _jsx(FormAddBusinessAFY, __assign({}, FormsBusinessDTO, { filters: [], damageBackup: props.damageBackup, insuredProperty: props.insuredProperty, dataForm: props.dataFormBusiness, ProvinceList: props.ProvinceList || [], TownList: props.TownList || [], SectorList: props.SectorList || [], businessShiftList: props.isCommerce ? businessShiftList : businessShiftServicesList, onClickCalculateRate: function () { }, 
            // onChangeCheckBox={() => {}}
            onChangeCheckBox: function (e, data) {
                props.onSameDirection(e, data);
            }, onChangeNumberValue: function noRefCheck() { }, onChangeSelect: function () { }, onClickCancel: function () { return props.setOpenModalAddBusiness(false); }, onNext: function noRefCheck() { } })) })));
};
